import {
    GoogleMap,
    InfoWindow,
    Marker,
    useJsApiLoader,
} from "@react-google-maps/api";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";

const containerStyle = {
    width: "100%",
    height: "400px",
};

const MapGoogle = ({ center, zoom, onMapClick, apiKey }) => {
    const { isLoaded } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: apiKey,
    });

    const [map, setMap] = useState(null);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [infoWindowOpen, setInfoWindowOpen] = useState(false);

    const obtenerDireccion = async (lat, lng) => {
        try {
            const response = await axios.get(
                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`
            );
            const addressComponents =
                response.data.results[0]?.address_components || [];
            const formattedAddress = addressComponents
                .map((component) => component.long_name)
                .join(", ");
            return formattedAddress || "Dirección no encontrada";
        } catch (error) {
            console.error("Error al obtener la dirección:", error);
            return "Error obteniendo la dirección";
        }
    };

    const onLoad = useCallback(
        (map) => {
            const bounds = new window.google.maps.LatLngBounds(center);
            map.fitBounds(bounds);
            setMap(map);
        },
        [center]
    );

    const onUnmount = useCallback(() => {
        setMap(null);
    }, []);

    const handleMapClick = async (event) => {
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        const direccion = await obtenerDireccion(lat, lng);
        onMapClick(lat, lng, direccion)
        setSelectedLocation({ lat, lng, direccion });
        //setInfoWindowOpen(true); // Abrir la ventana de información
    };

    useEffect(() => {
        if (center.lat && center.lng) {
            setSelectedLocation(center);
        }
    }, [center]);

    return isLoaded ? (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={18}
            onLoad={onLoad}
            onUnmount={onUnmount}
            onClick={handleMapClick}
            options={{
                zoomControl: true,
                streetViewControl: false,
                mapTypeControl: false,
            }}
        >
            {selectedLocation && (
                <Marker
                    position={{ lat: selectedLocation.lat, lng: selectedLocation.lng }}
                    onClick={() => setInfoWindowOpen(true)}
                >
                    {infoWindowOpen && (
                        <InfoWindow
                            position={{
                                lat: selectedLocation.lat,
                                lng: selectedLocation.lng,
                            }}
                            onCloseClick={() => setInfoWindowOpen(false)} // Cerrar la ventana de información
                        >
                            <div>
                                <p>Latitud: {selectedLocation.lat}</p>
                                <p>Longitud: {selectedLocation.lng}</p>
                                <p>Dirección: {selectedLocation.direccion}</p>
                            </div>
                        </InfoWindow>
                    )}
                </Marker>
            )}
        </GoogleMap>
    ) : (
        <></>
    );
};

export default React.memo(MapGoogle);